import React from "react";
import { useRive } from "@rive-app/react-canvas";
import "../styles/components/AvatarLevelUpTitle.scss";
import rain_world_iterator_halo from "./rain_world_iterator_halo.riv";
import { getAvatarLevelClass } from "./levelUtils";

const AvatarLevelUpTitle = ({ avatarUrl, level }) => {
    const levelClass = getAvatarLevelClass(level);

    // Chargement du composant Rive avec gestion d'erreur
    let RiveComponent = null;
    let isRiveLoaded = false;

    try {
        const riveHook = useRive({
            src: rain_world_iterator_halo,
            autoplay: true,
        });

        RiveComponent = riveHook.RiveComponent;
        isRiveLoaded = true;
    } catch (error) {
        console.warn("[AvatarLevelUpTitle] Erreur chargement Rive:", error);
        isRiveLoaded = false;
    }

    return (
        <div className={`avatarDuForum-container ${levelClass}`}>
            {levelClass === "level-10" && isRiveLoaded && RiveComponent && (
                <div
                    className="forum-post"
                    style={{
                        position: "absolute",
                        top: "-50%",
                        left: "-50%",
                        width: "200%",
                        height: "200%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 0,
                        pointerEvents: "none",
                    }}
                >
                    <RiveComponent
                        style={{
                            width: "100%",
                            height: "100%",
                            zIndex: 0,
                        }}
                    />
                </div>
            )}

            {levelClass === "level-10" && !isRiveLoaded && (
                <div
                    className="forum-post-fallback"
                    style={{
                        position: "absolute",
                        top: "-50%",
                        left: "-50%",
                        width: "200%",
                        height: "200%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "50%",
                        background:
                            "radial-gradient(circle, rgba(255,51,204,0.2) 0%, rgba(0,255,255,0.1) 50%, transparent 80%)",
                        zIndex: 0,
                        pointerEvents: "none",
                    }}
                >
                    <div
                        style={{
                            width: "80%",
                            height: "80%",
                            border: "2px solid rgba(255,51,204,0.6)",
                            borderRadius: "50%",
                            animation:
                                "moviefrenzy-halo-pulse 3s ease-in-out infinite",
                            boxShadow:
                                "0 0 30px rgba(255,51,204,0.4), inset 0 0 30px rgba(0,255,255,0.2)",
                        }}
                    ></div>
                </div>
            )}

            <div
                className={`avatarDuForum-border ${levelClass}`}
                style={{ zIndex: 2, position: "relative" }}
            >
                <img
                    src={avatarUrl}
                    alt="Avatar"
                    className="avatarDuForum-image"
                />
            </div>
        </div>
    );
};

export default AvatarLevelUpTitle;




